// src/redux/store.ts
import {
  FLUSH, PAUSE, PERSIST,
  persistStore, PURGE, REGISTER, REHYDRATE,
} from 'redux-persist';
import {
  configureStore, Action, Slice, combineReducers, Middleware,
} from '@reduxjs/toolkit';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import HomeSlice from '../views/home/slice/slice';
import ContactSlice from '../views/contact/slice/slice';
import WordsListsSlice from '../views/words-lists/slice/slice';
import WordsListSlice from '../views/words-list/slice/slice';
import FoldersSlice from '../views/folders/slice/slice';
import MemorySlice from '../views/memory/slice/slice';
import FindSlice from '../views/find/slice/slice';
import LetterSlice from '../views/kiddo-games/letters/slice/slice';
import PairingWordsSlice from '../views/pairing/slice/slice';
import WritingSlice from '../views/writing/slice/slice';
import AuthSlice from '../views/auth/slice/slice';
import StudentSlice from '../views/student/slice/slice';
import StudentWordsListsSlice from '../views/student-words-list/slice/slice';

export const mapSliceToReducers = (slices: Slice[]) => slices
  .map((slice) => ({ [slice.name]: slice.reducer }))
  .reduce((previous, current) => ({ ...previous, ...current }), {});
// Action types that require refresh - moved here to avoid circular dependency
// export const FOLDER_REFRESH_ACTIONS = {
//   FULL_REFRESH: [
//     'folders/finishCreatingFolder',
//     'folders/finishDeletingFolder',
//     'words-lists/finishAddingWordsList',
//     'words-lists/finishDeletingWordsList',
//     'words-lists/addWordsListToList',
//     'words-lists/removeWordsList',
//   ],
//   CACHE_INVALIDATION: [
//     'folders/finishRenamingItem',
//     'folders/finishMovingItem',
//     'words-lists/finishSharingWordsList',
//   ],
// };
// MIDDLEWARE dla automatycznego odświeżania folderów
// const createFolderRefreshMiddleware = (): Middleware => {
// // Debounced refresh - grupuje wiele akcji w jedno odświeżenie
//   const debouncedRefresh = debounce((store: any) => {
//     console.log('[Middleware] Triggering folder tree refresh');
//     // Dispatch action directly to slice instead of importing from actions
//     store.dispatch({
//       type: 'folders/triggerTreeRefresh',
//       payload: { forceRefresh: true },
//     });
//   }, 500);

//   return (store) => (next) => (action) => {
//     const result = next(action);
//     // Sprawdź czy akcja wymaga pełnego odświeżenia
//     if (FOLDER_REFRESH_ACTIONS.FULL_REFRESH.includes(action.type)) {
//       const state = store.getState();
//       const hasError = state.folders?.createFolderError
//                    || state.folders?.deleteFolderError
//                    || state['words-lists']?.addingError
//                    || state['words-lists']?.deletingError;

//       if (!hasError) {
//         debouncedRefresh(store);
//       }
//     }

//     // Sprawdź czy akcja wymaga tylko invalidacji cache
//     if (FOLDER_REFRESH_ACTIONS.CACHE_INVALIDATION.includes(action.type)) {
//       store.dispatch({ type: 'folders/setNeedsRefresh', payload: true });
//     }

//     return result;
//   };
// };
// Middleware dla logowania akcji (pomocne w debugowaniu)
const loggingMiddleware: Middleware = () => (next) => (action) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[Redux Action]', action.type);
  }

  return next(action);
};
// Kombinuj reducery
const reducer = combineReducers(mapSliceToReducers(
  [
    HomeSlice,
    FindSlice,
    LetterSlice,
    MemorySlice,
    ContactSlice,
    PairingWordsSlice,
    WritingSlice,
    StudentWordsListsSlice,
    WordsListsSlice,
    WordsListSlice,
    FoldersSlice,
    AuthSlice,
    StudentSlice,
  ],
));
// Konfiguracja store z middleware
const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          // 'folders/setFolderChildren',
          // 'folders/optimisticUpdate',
          // 'folders/triggerTreeRefresh',
        ],
        // ignoredPaths: [
        //   'folders.loadedFolders',
        //   'folders.loadingFolders',
        //   'folders.pendingChanges',
        // ],
      },
    });
    // Dodaj folder refresh middleware
    // middlewares.push(createFolderRefreshMiddleware());

    // Dodaj logging middleware tylko w development
    if (process.env.NODE_ENV === 'development') {
      middlewares.push(loggingMiddleware);
    }

    return middlewares;
  },
});
const persistor = persistStore(store);
export { store, persistor };
// Typy
export type RootState = ReturnType<typeof reducer>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, null, Action<string>>;
export type AppDispatch = ThunkDispatch<RootState, null, Action<string>>;
